export const zIndex = {
  basic: '0',
  overlay: '10',
  toast: '20',
  modal: '30',
  'modal-2': '40',
  'modal-3': '50'
}
